import { ReactNode } from "react";
import { ActualProtectionTokenFragment } from "gql/graphql";
import { Context } from "./context";
import { useContextTokens } from "@/shared/security/model/context-tokens/use-context-tokens";

export function ContextTokensProvider({
  children,
  tokens,
}: {
  children: ReactNode;
  tokens: ActualProtectionTokenFragment[];
}) {
  const upperContextTokens = useContextTokens();

  return (
    <Context.Provider value={upperContextTokens.concat(tokens)}>
      {children}
    </Context.Provider>
  );
}
